import React, { ComponentProps, FC, useRef, useState } from 'react';

import { track } from '@adsk/acs-web-analytics';
import SearchField from '@adsk/alloy-react-search-field';

import { DEFAULT_SEARCH_BAR_DELAY } from '../../constants';

type SearchBarProps = ComponentProps<typeof SearchField> & {
  delay?: boolean;
  delayTime?: number;
  value?: string;
  analyticsEvents?: { searchBarQueryChange: string };
};

export const SearchBar: FC<SearchBarProps> = ({
  delay = true,
  delayTime = DEFAULT_SEARCH_BAR_DELAY,
  onChange,
  value = '',
  analyticsEvents,
  ...searchBarProps
}) => {
  const currentTimeout = useRef<number>(0);

  const [currentQuery, setCurrentQuery] = useState<string>(value);

  const handleQueryChange = (newQuery: string) => {
    setCurrentQuery(newQuery);
    if (delay) {
      clearTimeout(currentTimeout.current);
      // Using window.setTimeout due to TS configuration try to use Node Timer
      const timeout = window.setTimeout(() => {
        if (analyticsEvents) {
          track(analyticsEvents.searchBarQueryChange, {
            searched_text: newQuery,
          });
        }

        if (onChange) {
          onChange(newQuery);
        }
      }, delayTime);
      currentTimeout.current = timeout;
    } else {
      onChange?.(newQuery);
    }
  };

  return (
    <SearchField
      {...searchBarProps}
      value={currentQuery}
      onChange={(query) => handleQueryChange(query)}
    />
  );
};
